interface WelcomeScreenProps {
  onNext: () => void;
}

export default function WelcomeScreen({ onNext }: WelcomeScreenProps) {
  return (
    <div
      className="
        fixed inset-0 
        h-screen
        bg-brandPurpleLight 
        flex flex-col 
        items-center 
        justify-center 
        p-4 
        z-50 
        relative
      "
    >
      {/* Top‐left frying pan */}
      <img
        src="/images/welcome_pan.png"
        alt="Decorative frying pan"
        className="
          absolute top-0 left-0 
          w-60 h-60 
          -translate-x-1/4 -translate-y-1/4 
          opacity-50 
          pointer-events-none
        "
      />

      {/* === Your Original Content === */}
      <h1 className="text-3xl font-bold mb-4 text-brandPurpleDark">
        Welcome to PanPals
      </h1>
      <p className="mb-8 text-center">
        Explore and share recipes, plan meals, and manage your grocery lists. All for free.
      </p>
      <button
        onClick={onNext}
        className="bg-white text-brandPurpleDark p-2 rounded-md border border-1 border-brandPurpleDark"
      >
        Get Started
      </button>

      {/* Bottom‐right cutting board */}
      <img
        src="/images/welcome_board.png"
        alt="Decorative cutting board"
        className="
          absolute bottom-0 right-0 
          w-60 h-52 
          translate-x-1/5 translate-y-1/5 
          opacity-50 
          pointer-events-none
        "
      />
    </div>
  );
}
